import React, { createContext, useContext, useState, useCallback, useMemo, } from 'react';
var ActiveSubmenuContext = createContext({
    activeSubmenu: null,
    setActiveSubmenu: function () {
        throw new Error('setActiveSubmenu function not provided by ActiveSubmenuContext Provider.');
    },
    clearActiveSubmenu: function () {
        throw new Error('clearActiveSubmenu function not provided by ActiveSubmenuContext Provider.');
    }
});
export var useActiveSubmenuContext = function () { return useContext(ActiveSubmenuContext); };
export var useActiveSubmenu = function (uid) {
    var _a = useActiveSubmenuContext(), activeSubmenu = _a.activeSubmenu, setActiveSubmenu = _a.setActiveSubmenu, clearActiveSubmenuCtx = _a.clearActiveSubmenu;
    var claimActiveSubmenu = useCallback(function () {
        setActiveSubmenu(uid);
    }, [setActiveSubmenu, uid]);
    var clearActiveSubmenu = useCallback(function () {
        if (uid) {
            clearActiveSubmenuCtx(uid);
        }
    }, [uid, clearActiveSubmenuCtx]);
    var clearActiveSubmenuNoDelay = useCallback(function () {
        setActiveSubmenu(null);
    }, [setActiveSubmenu]);
    return {
        activeSubmenu: activeSubmenu,
        isActiveSubmenu: activeSubmenu === uid,
        clearActiveSubmenu: clearActiveSubmenu,
        claimActiveSubmenu: claimActiveSubmenu,
        clearActiveSubmenuNoDelay: clearActiveSubmenuNoDelay
    };
};
export var ActiveSubmenuContextProvider = function (_a) {
    var children = _a.children;
    var _b = useState(null), activeSubmenu = _b[0], setActiveSubmenu = _b[1];
    var clearActiveSubmenu = useCallback(function () {
        setActiveSubmenu(null);
    }, [setActiveSubmenu]);
    var contextValue = useMemo(function () { return ({
        activeSubmenu: activeSubmenu,
        setActiveSubmenu: setActiveSubmenu,
        clearActiveSubmenu: clearActiveSubmenu
    }); }, [activeSubmenu, clearActiveSubmenu]);
    return (React.createElement(ActiveSubmenuContext.Provider, { value: contextValue }, children));
};
